"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _BrandIcons = require("../BrandIcons");

var _core = require("@emotion/core");

var SvgBPhysicalCardPositive = function SvgBPhysicalCardPositive(props) {
  return (0, _core.jsx)(_BrandIcons.BrandIcons, props, (0, _core.jsx)("g", {
    fill: "none",
    fillRule: "evenodd"
  }, (0, _core.jsx)("path", {
    d: "M18.755 90.425h-5.409C6.016 90.433.068 84.499.056 77.17V13.248A13.27 13.27 0 0113.346 0h116.928c7.318.008 13.248 5.938 13.255 13.255v16.247a2.107 2.107 0 11-4.214 0V13.255a9.054 9.054 0 00-9.04-9.04H13.345a9.047 9.047 0 00-9.075 9.04v63.922a9.054 9.054 0 009.075 9.033h5.41a2.107 2.107 0 010 4.215z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M130.24 90.425H31.897a2.107 2.107 0 110-4.215h98.341a9.054 9.054 0 009.04-9.04V43.98H15.37a2.107 2.107 0 110-4.215h126.053c1.164 0 2.107.944 2.107 2.107l-.035 35.298c-.007 7.317-5.937 13.247-13.255 13.255z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M25.4 57.27H15.37a2.107 2.107 0 110-4.215H25.4a2.107 2.107 0 110 4.215zM48.532 57.27H38.5a2.107 2.107 0 010-4.215h10.03a2.107 2.107 0 110 4.215zM128.237 27.395H2.107A2.11 2.11 0 010 25.24l.057-5.486v-6.498A13.27 13.27 0 0113.346 0h30.992a2.107 2.107 0 010 4.215H13.346a9.047 9.047 0 00-9.075 9.04l-.056 9.925h124.022a2.107 2.107 0 010 4.215z",
    fill: "#285"
  })));
};

var _default = SvgBPhysicalCardPositive;
exports["default"] = _default;